import {
  AdFieldBathsEnum,
  AdFieldBedsEnum,
  AdFieldFloorEnum,
  AdFieldFurnitureEnum,
  AdFieldOccupancyEnum,
  AdFieldRenovationEnum,
} from '../../types/enums';

export const PROPERTY_AD_BEDS_OPTIONS = [
  { label: 'Studio', value: AdFieldBedsEnum.Studio },
  { label: '1', value: AdFieldBedsEnum.One },
  { label: '2', value: AdFieldBedsEnum.Two },
  { label: '3', value: AdFieldBedsEnum.Three },
  { label: '4', value: AdFieldBedsEnum.Four },
  { label: '5', value: AdFieldBedsEnum.Five },
  { label: '6', value: AdFieldBedsEnum.Six },
  { label: '7', value: AdFieldBedsEnum.Seven },
  { label: '8+', value: AdFieldBedsEnum.EightPlus },
] as const;

export const PROPERTY_AD_BATHS_OPTIONS = [
  { label: '1', value: AdFieldBathsEnum.One },
  { label: '2', value: AdFieldBathsEnum.Two },
  { label: '3', value: AdFieldBathsEnum.Three },
  { label: '4', value: AdFieldBathsEnum.Four },
  { label: '5', value: AdFieldBathsEnum.Five },
  { label: '6', value: AdFieldBathsEnum.Six },
  { label: '7', value: AdFieldBathsEnum.Seven },
  { label: '8+', value: AdFieldBathsEnum.EightPlus },
] as const;

export const PROPERTY_AD_FLOOR_OPTIONS = [
  { label: 'Low', value: AdFieldFloorEnum.Low },
  { label: 'Middle', value: AdFieldFloorEnum.Middle },
  { label: 'High', value: AdFieldFloorEnum.High },
] as const;

export const PROPERTY_AD_FURNITURE_OPTIONS = [
  { label: 'Furnished', value: AdFieldFurnitureEnum.Furnished },
  { label: 'Partly furnished', value: AdFieldFurnitureEnum.PartlyFurnished },
  { label: 'Unfurnished', value: AdFieldFurnitureEnum.Unfurnished },
] as const;

export const PROPERTY_AD_RENOVATION_OPTIONS = [
  { label: 'Renovated', value: AdFieldRenovationEnum.Renovation },
  { label: 'Non renovated', value: AdFieldRenovationEnum.NonRenovation },
] as const;

export const PROPERTY_AD_OCCUPANCY_OPTIONS = [
  { label: 'Vacant', value: AdFieldOccupancyEnum.Vacant },
  { label: 'Rented', value: AdFieldOccupancyEnum.Tenanted },
] as const;

export const PROPERTY_AD_VIEW_OPTIONS = [
  'Sea',
  'Park',
  'Marina',
  'Downtown',
  'Burj Khalifa',
  'Lake',
  'Pool',
  'Community',
  'Golf Course',
  'Skyline',
  'Canal',
  'Desert',
  'City',
  'Garden',
  'Landmark',
  'Beach',
  'Palm',
  'Open',
  'Road',
  'Courtyard',
  'Mosque',
] as const;
